var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 82,
    viewBox: "0 0 106 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 104,
    height: 80,
    rx: 6,
    fill: "#F5F3F1",
    stroke: "#ECEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.68629 3.68629 1 7 1H99C102.314 1 105 3.68629 105 7V12.6364H1V7Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06463 8.27237C9.8554 8.27237 10.4964 7.62115 10.4964 6.81783C10.4964 6.0145 9.8554 5.36328 9.06463 5.36328C8.27386 5.36328 7.63281 6.0145 7.63281 6.81783C7.63281 7.62115 8.27386 8.27237 9.06463 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8361 8.27237C14.6269 8.27237 15.2679 7.62115 15.2679 6.81783C15.2679 6.0145 14.6269 5.36328 13.8361 5.36328C13.0453 5.36328 12.4043 6.0145 12.4043 6.81783C12.4043 7.62115 13.0453 8.27237 13.8361 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6096 8.27237C19.4003 8.27237 20.0414 7.62115 20.0414 6.81783C20.0414 6.0145 19.4003 5.36328 18.6096 5.36328C17.8188 5.36328 17.1777 6.0145 17.1777 6.81783C17.1777 7.62115 17.8188 8.27237 18.6096 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3201 51.7288L61.0018 44.4108C59.5581 42.9672 57.402 42.686 55.6646 43.5421L49.0025 36.8803V32.9994L41.0029 27L37.0031 30.9996L43.0028 38.9988H46.8838L53.546 45.6607C52.696 47.398 52.971 49.554 54.4147 50.9977L61.733 58.3157C62.6454 59.2281 64.1204 59.2281 65.0266 58.3157L68.3201 55.0223C69.2263 54.1099 69.2263 52.635 68.3201 51.7288ZM57.7332 41.0611C59.5019 41.0611 61.1643 41.7486 62.4142 42.9984L63.6266 44.2108C64.6141 43.7796 65.5515 43.1797 66.364 42.3672C68.6826 40.0487 69.4701 36.7865 68.7326 33.8243C68.5951 33.2619 67.8889 33.0682 67.4764 33.4806L62.8267 38.1302L58.5832 37.424L57.877 33.1806L62.5267 28.5311C62.9392 28.1186 62.7392 27.4125 62.1705 27.2687C59.2081 26.5375 55.9458 27.325 53.6334 29.6372C51.8523 31.4183 51.0148 33.7681 51.0586 36.1116L56.1896 41.2424C56.6958 41.1236 57.2207 41.0611 57.7332 41.0611ZM51.2398 46.1856L47.6963 42.6422L38.1718 52.1725C36.6094 53.7349 36.6094 56.2659 38.1718 57.8282C39.7342 59.3906 42.2653 59.3906 43.8277 57.8282L51.5523 50.104C51.0773 48.8604 50.9336 47.5042 51.2398 46.1856ZM41.0029 56.4971C40.1779 56.4971 39.503 55.8222 39.503 54.9973C39.503 54.1661 40.1717 53.4974 41.0029 53.4974C41.8341 53.4974 42.5028 54.1661 42.5028 54.9973C42.5028 55.8222 41.8341 56.4971 41.0029 56.4971Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-icon.a8973db7487c6737f7ab32a1ec7d8864.svg";
export { ForwardRef as ReactComponent };